import Logan from 'logan-web';

export default function ({ app }, inject) {
  // eslint-disable-next-line import/no-named-as-default-member
  Logan.initConfig({
    reportUrl: '/s/',
  });

  inject('Logan', Logan);
}
